<template>
  <div>
    <qrcode-stream @decode="onDecode" @init="onInit" />

    <div>
      <p>{{ message }}</p>
      <p v-if="error">{{ error }}</p>
    </div>
  </div>
</template>


<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'

const api = new APIService()
const auth = new AuthService()

export default {
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture
  },
  data() {
    return {
      message: '',
      error: ''
    }
  },
  mounted() {
    // TODO: check if loggedInUser has role to scan pass or actual owner of the pass
  },
  methods: {
    onDecode (decodedString) {
      const self = this
      self.message = 'Decoding...'
      const fields = {
        qrcode_value: decodedString,
        scanned_by_user_id: auth.getUserId()
      }
      this.decodedString = fields

      api.createScanPass(fields).then((d) => {
        self.message = d.response_message
        self.refreshMessage()
      }).catch((e) => {
        self.message = e
      })
    },
    refreshMessage() {
      const self = this
      setTimeout(function(){
        self.message = ''
      }, 3000)
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/containers/ScanPass.vue